angular.module('impactx.basket').controller('BasketItemBulkChangeDialogCtrl', BasketItemBulkChangeDialogCtrl);

BasketItemBulkChangeDialogCtrl.$inject = ['$scope', 'dataGen', '$mdDialog', 'themeFactory', 'TranslationService',
    'ToastService', 'selectedIds', 'bkhId', 'viewMode', 'helperDialogParams'];

function BasketItemBulkChangeDialogCtrl($scope, dataGen, $mdDialog, themeFactory, TranslationService,
                                        ToastService, selectedIds, bkhId, viewMode, helperDialogParams)
{
    var ctrl = this;

    var types = {};

    $scope.theme = themeFactory.getTheme();
    $scope.applyLabel = TranslationService.get('accept');
    $scope.abortLabel = TranslationService.get('abort');
    ctrl.helperDialogParams = helperDialogParams;
    ctrl.additionalAdrData = { multipleItems: true };

    dataGen.getData($scope, {selectedIds: selectedIds, bkhId: bkhId, viewMode: viewMode}, "/basket/bulkchange/view").then(function () {
        $scope.data.minDate = new Date();
    });

    ctrl.apply = function() {
        dataGen.postAsForm($scope, {data: $scope.data}, "/basket/bulkchange/save").then(function () {
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    ctrl.cancel = function(){
        $mdDialog.cancel();
    };

    ctrl.toogleChangeAAT = function () {
        if (!$scope.data.changeAAT) {
            $scope.data.aat.selected.id = 0;
            ctrl.changeAAT(0);
        }
    };

    ctrl.changeAAT = function (selectedAATId) {
        var tempScope = {};
        dataGen.getData(tempScope, {aatId: selectedAATId, bksId: 0, bkiId: 0}, '/basket/input/controlstructure').then(function () {
            $scope.data.aat = tempScope.data.aat;
            $scope.data.control = tempScope.data.control;
        });
    };

    ctrl.getTypes = function () {
        types.delivery = !!$scope.data.deliveryAddresses;
        types.handover = !!$scope.data.handOverAddresses;
        types.invoice = !!$scope.data.invoiceAddresses;
        types.contact = !!$scope.data.contactAddresses;
        return types;
    };

}